exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label[data-v-f6bf4e36]{font-size:16px;font-weight:400}.data-details[data-v-f6bf4e36]{margin-bottom:100px}.icon-group[data-v-f6bf4e36]{position:relative;padding-left:40px}.icon-group label[data-v-f6bf4e36]{font-size:14px;color:#67635f;margin:0}.icon-group input[disabled][data-v-f6bf4e36]{height:18px;padding:0;line-height:1;border-radius:0}.icon-img[data-v-f6bf4e36]{width:15px;height:auto;position:absolute;top:5px;left:15px}.icon-img--big[data-v-f6bf4e36]{width:18px;top:10px}.arrow-img[data-v-f6bf4e36]{height:7px;margin-bottom:4px}.custom-span span[data-v-f6bf4e36]{height:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6bf4e36","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/my-data/risk-factors.vue
// module id = 895
// module chunks = 0